/*
 * @Author: Vanny
 * @Date: 2019-09-18 10:02:33
 * @LastEditors: Vanny
 * @LastEditTime: 2019-12-05 21:34:48
 * @Description: 本地存储
 */

// 本地存储字段
export const STORAGE = {
  REPORT: {
    SETTING: 'v3-report-settings',
  },
  LOCALE: {
    MAP: 'locale-map',
  },
  SYSTEM_KEEP_LOGIN: 'system_keep_login',
  BASIC_DATA_IS_REPEATEDLY_DISPLAYED_DURING_EXPORT: 'basic_data_is_repeatedly_displayed_during_export',
  ADMIN_TOKEN:'admin_token',
  ADMIN_MASK_TOKEN:'admin_mask_token'
};

export const getStorage = (key: string, isLocal = true) => {
  const val = isLocal ? localStorage.getItem(key) : sessionStorage.getItem(key);

  try {
    return val ? JSON.parse(val) : val;
  } catch (e) {
    return val;
  }
};

export const setStorage = (key: string, value: any, isLocal = true) => {
  const val = typeof value === 'string' ? value : JSON.stringify(value);

  if (isLocal) {
    localStorage.setItem(key, val);
  } else {
    sessionStorage.setItem(key, val);
  }
};

export const removeStorage = (key: string, isLocal = true) => {
  if (isLocal) {
    localStorage.removeItem(key);
  } else {
    sessionStorage.removeItem(key);
  }
};

export const clearStorage = (isLocal = true) => {
  if (isLocal) {
    localStorage.clear();
  } else {
    sessionStorage.clear();
  }
};
